import React from "react";
import { X, FileText, AlertCircle } from "lucide-react";
import "./GuidelinesModal.css";

const GuidelinesModal = ({ isOpen, onClose, guidelines, communityName }) => {
  if (!isOpen) return null;

  return (
    <div className="guidelines-modal-overlay" onClick={onClose}>
      <div className="guidelines-modal" onClick={(e) => e.stopPropagation()}>
        <div className="guidelines-modal-header">
          <div className="modal-title">
            <FileText size={24} />
            <div>
              <h2>Community Guidelines</h2>
              <p>Rules and guidelines for "{communityName}"</p>
            </div>
          </div>
          <button onClick={onClose} className="close-button">
            <X size={20} />
          </button>
        </div>

        <div className="guidelines-modal-content">
          {guidelines && guidelines.length > 0 ? (
            <div className="guidelines-list">
              {guidelines.map((guideline, index) => {
return (
                  <div key={guideline._id || index} className="guideline-item">
                    <div
                      className="guideline-number"
                      style={{
                        backgroundColor: "#ef4444",
                        color: "#ffffff",
                        width: "32px",
                        height: "32px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "8px",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      {index + 1}
                    </div>
                    <div className="guideline-content">
                      <h3>{guideline.title}</h3>
                      <p>{guideline.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="empty-guidelines">
              <AlertCircle size={48} />
              <h3>No Guidelines Available</h3>
              <p>This community hasn't published any guidelines yet.</p>
            </div>
          )}
        </div>

        <div className="guidelines-modal-footer">
          <p>
            Please follow these guidelines to maintain a respectful and
            productive community environment.
          </p>
        </div>
      </div>
    </div>
  );
};

export default GuidelinesModal;
